import { useState, useEffect } from 'react';
import type { TrackingLinkStatus } from '../types';
import { getRemainingTimeWithDate } from '../utils/helpers';

export const useRealTimeCountdown = (
  expirationDate: any,
  status: TrackingLinkStatus | null,
) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update every second
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Clear interval on unmount
    return () => clearInterval(timer);
  }, []);

  return getRemainingTimeWithDate(expirationDate, status, currentTime);
};
